import styled from 'styled-components';
import {dFlex, dFlexColumn, alignCenter} from '../../../../globalVariables/GlobalFlex';
import {agentTextFieldBase} from '../aiAgentTextField/AiAgentTextField.css';

export const card = styled.div`
    ${dFlexColumn}
    gap: var(--space-sm);
    width: 100%;
    text-align: start;
`;

export const title = styled.span`
    font-size: var(--font-size-body);
    font-weight: var(--font-weight-bold);
    line-height: 1.35;
    color: var(--color-text-default);
`;

export const question = styled.span`
    font-size: var(--font-size-body-small);
    line-height: 1.35;
    color: var(--color-text-subtle);
`;

export const starsRow = styled.div`
    ${dFlex}
    ${alignCenter}
    gap: var(--space-xs);
`;

export const starButton = styled.button<{$active: boolean}>`
    ${dFlex}
    padding: var(--space-xs);
    border: none;
    background: none;
    cursor: pointer;
    color: ${({$active}) => ($active ? 'var(--color-state-warning-main)' : 'var(--color-text-subtle)')};
    transition: transform 0.15s ease, color 0.15s ease;

    &:hover:not(:disabled) {
        transform: scale(1.15);
    }

    &:disabled {
        cursor: default;
        opacity: 0.6;
    }
`;

export const textField = styled.textarea`
    ${agentTextFieldBase}
    min-height: 72px;
    padding: var(--space-sm) var(--space-md);
    border: 1px solid var(--color-border-subtle);
    border-radius: var(--border-radius-border-radius-md, 8px);
    background: var(--color-bg-base);
    font-size: var(--font-size-body-small);
    line-height: 1.4;
    resize: vertical;

    &:focus {
        border-color: var(--color-border-default);
    }
`;

export const actions = styled.div`
    ${dFlex}
    gap: var(--space-sm);
    margin-top: var(--space-xs);

    > button {
        flex: 1;
    }
`;

export const thanks = styled.span`
    font-size: var(--font-size-body);
    line-height: 1.4;
    color: var(--color-text-default);
`;
